// extracted by mini-css-extract-plugin
module.exports = {"hintIconWrapper":"Question_hintIconWrapper__fvRCJ"};